"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InferenceReportEntryBaseSchema = void 0;
const zod_1 = require("zod");
exports.InferenceReportEntryBaseSchema = zod_1.z.object({
    source: zod_1.z.string(),
    inferenceProvider: zod_1.z.string().optional(),
    inferenceSources: zod_1.z.string().array().optional(),
    explanation: zod_1.z.string().optional(),
});
//# sourceMappingURL=InferenceReportEntryBase.js.map